var map = {
	"./1.png": "1e0f",
	"./2.png": "c066",
	"./3.png": "3b8b",
	"./cloud-01.png": "4c28",
	"./horisontal.png": "0ae2",
	"./large.png": "8960",
	"./large2.png": "4749",
	"./moon-01.png": "adf4",
	"./red.png": "8b3a",
	"./small.png": "12a1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "dc55";